import { render, staticRenderFns } from "./RoleAccessUpdate.vue?vue&type=template&id=6a63f1cc&scoped=true"
import script from "./RoleAccessUpdate.vue?vue&type=script&lang=js"
export * from "./RoleAccessUpdate.vue?vue&type=script&lang=js"
import style0 from "./RoleAccessUpdate.vue?vue&type=style&index=0&id=6a63f1cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a63f1cc",
  null
  
)

export default component.exports